const isResponseSuccessful = (res) => {
  return res?.status >= 200 && res?.status < 300;
};

const responseUtil = { isResponseSuccessful };

export default responseUtil;
